export default __webpack_public_path__ + "static/media/cloud-computing.f7c2b635.png";